import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import CartDrawer from "@/components/cart/CartDrawer";
import FloatingWhatsApp from "@/components/common/FloatingWhatsApp";

/**
 * The Suspense boundary sits around the outlet rather than the whole layout, so
 * a code-split page loads underneath a header and footer that never flicker.
 * The min-height holds the page open so the footer does not jump up and back.
 */
export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      {/* Must clear the fixed header (88px) — keep these two in step. */}
      <main className="flex-1 pt-[106px]">
        <Suspense fallback={<div className="min-h-[70vh]" aria-busy="true" />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
      <CartDrawer />
      <FloatingWhatsApp />
    </div>
  );
}
